/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PipelineRunRequest
 */
export interface PipelineRunRequest {
    /**
     * 
     * @type {string}
     * @memberof PipelineRunRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the PipelineRunRequest interface.
 */
export function instanceOfPipelineRunRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function PipelineRunRequestFromJSON(json: any): PipelineRunRequest {
    return PipelineRunRequestFromJSONTyped(json, false);
}

export function PipelineRunRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PipelineRunRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function PipelineRunRequestToJSON(value?: PipelineRunRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
    };
}

